export default __webpack_public_path__ + "8107eb94e63c133d1c29a846658900b4.woff2";